<template>
		<modal :value="displayModal" effect="fade">
			<div slot="modal-header" class="modal-header">
				<h4 class="modal-title">
					<b>Message</b>
				</h4>
			</div>
		  	Vous pouvez commencer votre formation
				<div slot="modal-footer" class="modal-footer">
					<button type="button" class="btn btn-default" @click="toggleUntoggle()">Ok</button>
				</div>
		</modal>
</template>

<script>
	import { modal as Modal } from 'vue-strap';

	export default {
		components: {
			Modal
		},
		computed: {
			displayModal: function()	{
				return this.$store.state.user.modalStartTraining;
			},
		},
		methods: {
			toggleUntoggle()	{
				this.$store.dispatch('toggleDisplay', !this.displayModal);
			}
		}
	};
</script>
